import React from "react";

export default function NotFound() {
  return <div className="background-notfound"></div>;
}
